import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreFollowedIdMapReducers } from './_idMap';
import { getCoreFollowedSlice } from './get';

import { coreFollowedAllReducers, coreFollowedAllWatchers } from './all';
import { postCoreFollowSlice, postCoreUnfollowSlice } from './post';

export const coreFollowersReducers = combineReducers({
	all: coreFollowedAllReducers,
	byId: coreFollowedIdMapReducers,
	follow: postCoreFollowSlice.asyncReducers,
	get: getCoreFollowedSlice.asyncReducers,
	unfollow: postCoreUnfollowSlice.asyncReducers
});

export const coreFollowersWatchers = combineAllWatchers([
	coreFollowedAllWatchers,
	getCoreFollowedSlice.asyncWatchers,
	postCoreFollowSlice.asyncWatchers,
	postCoreUnfollowSlice.asyncWatchers
]);
